import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  DELETE_REASON_OPTIONS,
  DeleteReason,
} from '../../../../constants/delete-reasons';

export interface DeleteOrderDialogData {
  invoiceNumber?: string;
}

export interface DeleteOrderDialogResult {
  reason: DeleteReason;
  notes: string;
}

@Component({
  selector: 'app-delete-order-dialog',
  template: `
    <h2 mat-dialog-title>DELETE THIS RECORD?</h2>
    <mat-dialog-content>
      <p class="delete-dialog-message">
        This action is intended only for an incorrect/duplicate record.
        Do not use DELETE for VOID, RETURN, EXCHANGE, or RE-DO.
      </p>
      <p *ngIf="data?.invoiceNumber" class="delete-dialog-invoice">
        Invoice: {{ data.invoiceNumber }}
      </p>
      <p class="delete-dialog-label">REASON FOR DELETE</p>
      <mat-radio-group [(ngModel)]="reason" class="delete-dialog-reasons">
        <mat-radio-button
          *ngFor="let option of options"
          class="delete-dialog-reason"
          [value]="option"
        >
          {{ option }}
        </mat-radio-button>
      </mat-radio-group>
      <mat-form-field *ngIf="reason === 'Other'" class="delete-dialog-field">
        <mat-label>NOTES</mat-label>
        <input matInput [(ngModel)]="notes" autocomplete="off" />
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="cancel()">CANCEL</button>
      <button
        mat-raised-button
        color="warn"
        type="button"
        [disabled]="!canConfirm"
        (click)="confirm()"
      >
        DELETE
      </button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      .delete-dialog-message {
        margin: 0 0 12px;
        font-size: 13px;
        line-height: 1.4;
      }
      .delete-dialog-invoice,
      .delete-dialog-label {
        margin: 0 0 12px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.6);
      }
      .delete-dialog-label {
        font-weight: 600;
        color: rgba(0, 0, 0, 0.87);
      }
      .delete-dialog-reasons {
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-bottom: 12px;
      }
      .delete-dialog-reason {
        display: block;
        white-space: normal;
      }
      .delete-dialog-field {
        width: 100%;
      }
    `,
  ],
})
export class DeleteOrderDialogComponent {
  options = DELETE_REASON_OPTIONS;
  reason: DeleteReason | '' = '';
  notes = '';

  constructor(
    public dialogRef: MatDialogRef<DeleteOrderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteOrderDialogData
  ) {}

  get canConfirm(): boolean {
    return !!this.reason;
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  confirm(): void {
    if (!this.canConfirm) {
      return;
    }
    this.dialogRef.close({
      reason: this.reason,
      notes: String(this.notes || '').trim(),
    } as DeleteOrderDialogResult);
  }
}
